import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ComparisonOperator } from 'src/app/core/api/models';
import { ComparisonOperatorEnumDisplay } from 'src/app/core/enums/display/comparison-operator.display';
import { AppInputType } from 'src/app/core/types/app-input-type.type';
import { PeriodicDateTimeConfig } from '../../periodic-date-time-picker/periodic-date-time-picker.component';
import { OutboxMessageAdvancedSearchRequest } from './../../../../core/api/models/outbox-message-advanced-search-request';

@Component({
    selector: 'form-field-Advanced-search',
    templateUrl: './form-field-advanced-search.component.html',
    styles: [
        `
      .menu-item,
      .clear {
        cursor: pointer;
      }
    `,
    ],
    standalone: false
})
export class FormFieldAdvancedSearchComponent implements OnInit {
  //#region properties
  @Input('min') input_min: number;
  @Input('value') value: any;
  @Input('startDateTime') startDateTime: any;
  @Input('endDateTime') endDateTime: any;
  @Input('type') input_type: AppInputType;
  @Input('isOnlyNumber') input_isOnlyNumber: boolean;
  @Input('fieldName') input_fieldName: string;
  @Input('enumName') input_enumName: string;
  @Input('operator') input_operator: any;

  @Input('showModel') showModel: OutboxMessageAdvancedSearchRequest;

  public ComparisonOperatorEnumDisplay: typeof ComparisonOperatorEnumDisplay =
    ComparisonOperatorEnumDisplay;
  numberOperators = [
    ComparisonOperator.EqualTo,
    ComparisonOperator.NotEqualTo,
    ComparisonOperator.GreaterThan,
    ComparisonOperator.LessThan,
    ComparisonOperator.GreaterThanOrEqual,
    ComparisonOperator.LessThanOrEqual,
  ];
  textOperators = [
    ComparisonOperator.Contains,
    ComparisonOperator.StartsWith,
    ComparisonOperator.EndsWith,
  ];
  toNumberOperators = [
    ComparisonOperator.EqualTo,
    ComparisonOperator.StartsWith,
    ComparisonOperator.EndsWith,
  ];
  smsTextOperators = [
    ComparisonOperator.EqualTo,
    ComparisonOperator.NotEqualTo,
    ComparisonOperator.Contains,
    ComparisonOperator.StartsWith,
    ComparisonOperator.EndsWith,
  ];
  enumOperators = [ComparisonOperator.EqualTo, ComparisonOperator.NotEqualTo];
  operatorIcons = [
    //None
    'mdi-menu-left', // none
    //Number
    'mdi-code-equal', //EqualTo
    'mdi-code-not-equal', //NotEqualTo
    'mdi-code-greater-than', //GreaterThan
    'mdi-code-less-than', //LessThan
    'mdi-code-greater-than-or-equal', //GreaterThanOrEqual
    'mdi-code-less-than-or-equal', //LessThanOrEqual
    //String
    'mdi-text-box-search-outline', //Contains
    'mdi-text-box-remove-outline', //NotContains
    'mdi-arrow-left', //StartsWith
    'mdi-arrow-right', //EndsWith
  ];
  //#endregion
  periodicDateTimeConfig: PeriodicDateTimeConfig;

  fields: string = 'pages.outboxMessages.advancedSearch.';
  label: string;

  @Output('value') output_value = new EventEmitter<any>();
  @Output('startDate') output_startDate = new EventEmitter<any>();
  @Output('endDate') output_endDate = new EventEmitter<any>();
  //#endregion

  constructor() {}

  ngOnInit(): void {
    this.label = this.fields + this.input_fieldName;
    this.periodicDateTimeConfig = {
      // form: this.form,
      startDateLabel: 'pages.outboxMessages.advancedSearch.sendStartDate',
      startTimeLabel: 'pages.outboxMessages.advancedSearch.sendStartHour',
      endDateLabel: 'pages.outboxMessages.advancedSearch.sendEndDate',
      endTimeLabel: 'pages.outboxMessages.advancedSearch.sendEndHour',
      responsiveClassName: 'md:tw-w-1/2',
      isAdvancedSearch: true,
      startDateTimeValue: this.startDateTime,
      endDateTimeValue: this.endDateTime,
      isHideClearBtn: true,
    };
  }

  emit() {
    if (!this.value && this.value != 0) this.value = undefined;
    this.output_value.emit(this.value);
  }

  emitStartDate() {
    if (!this.startDateTime) this.startDateTime = undefined;
    this.output_startDate.emit(this.startDateTime);
  }

  emitEndDate() {
    if (!this.endDateTime) this.endDateTime = undefined;
    this.output_endDate.emit(this.endDateTime);
  }

  clearValue(fieldName) {
    this.showModel[fieldName] = undefined;
  }

  submitWithOperator(operator, fieldName: string) {
    if (!this.showModel[fieldName]) {
      this.showModel[fieldName] = {};
    }
    this.showModel[fieldName].operator = operator;
  }
}
